define('views/blocks/paymentModeProviders/CashOnDeliveryView',['underscore','app',
        'PaymentModeSelectionBoardView',
        'InputView',
        'template!blocks/paymentmodes/cashondelivery',
    ],function(_,app,
           PaymentModeSelectionBoardView,
           InputView,
           cashOnDeliveryTemplate
   ){
    return PaymentModeSelectionBoardView.extend({
        name:'return-money',
        classlist:'payment-mode__selection__form--simple',
        eventsOverride:{
            'click .btn-ignore':'ignore',
        },
        renderInner:function(){
            var paymentMode = this.paymentMode;
            return cashOnDeliveryTemplate({
                title: paymentMode.getParam('return_money_title'),
                label: paymentMode.getParam('return_money_label'),
                return_money:paymentMode.getOption('return_money','')
            });
            InputView.initializeInputsOfView(this);
        },
        ignore:function(){
            var view = this;
            view.paymentMode.setOption('return_money',0);
            view.close();
        },
        submitForm:function(e){
            var view = this,
                return_money = ''+view.$('[name=return_money]').val(),
                paymentMode = view.paymentMode;
            return_money = parseFloat(return_money.replace(',','.'));
            if(_.isNaN(return_money) || return_money<=0) return_money = 0;
            paymentMode.setOption('return_money',return_money);
            view.close();
            e.preventDefault();
            return false;
        }
    });
});
